import React from 'react'
import styled from 'styled-components';
import { Layout } from 'antd';

const { Content } = Layout;

const StyledContent = styled(Content)`
  color: ${props => props.theme.TextColor};
  background-color: ${props => props.theme.LayoutBodyBackground};
`

const Wrapper = styled.div`
	//margin: 4rem auto 2rem auto;
  margin: 0 auto;
  padding: ${props => !props.noPadding && '0 2rem'};

	@media (max-width: 900px) {
		padding: 0;
	}
`

const NwContent = ({ noPadding, children }) => {
  return (
    <StyledContent>
      <Wrapper noPadding={noPadding}>
        {children}
      </Wrapper>
    </StyledContent>
  )
}

export default NwContent

